import React from 'react';
import {Link} from 'react-router-dom';
import 'antd/dist/antd.css';
import './index.css';
import { Layout, Menu, Breadcrumb } from 'antd';
import {
  HomeOutlined,
  CalendarOutlined,
  SettingOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';

const { Content, Sider, Header } = Layout;
const { SubMenu } = Menu;

class Users extends React.Component {
  state = {
    collapsed: false,
  };

  onCollapse = collapsed => {
    console.log(collapsed);
    this.setState({ collapsed });
  };

  render() {
    const { collapsed } = this.state;
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible collapsed={collapsed} onCollapse={this.onCollapse}>
          <div className="logo" />
          <Menu theme="dark" defaultSelectedKeys={['3']} mode="inline">
            <Menu.Item key="10" icon={<HomeOutlined />}>
                <Link to="/">Home</Link>
            </Menu.Item>
            <Menu.Item key="9" icon={<CalendarOutlined />}>
                <Link to="/appointments/">Turnos </Link>
            </Menu.Item>
            <Menu.Item key="1" icon={<UserOutlined />}>
                <Link to="/pacients/">Pacientes</Link>
            </Menu.Item>
            <Menu.Item key="2" icon={<TeamOutlined />}>
                <Link to="/profesionals/">Profesionales</Link>
            </Menu.Item>
            <SubMenu key="sub1" icon={<SettingOutlined />} title="Configuracion">
                <Menu.Item key="3">
                  <Link to="/users/">Usuarios</Link>
                </Menu.Item>
            </SubMenu>
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <Header />
          <Content style={{ margin: '0 16px' }}>
            <Breadcrumb style={{ margin: '16px 0' }}>
              <Breadcrumb.Item>Configuracion</Breadcrumb.Item>
              <Breadcrumb.Item>Usuarios</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background" style={{ padding: 24 }}>
            </div>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default Users;